<template>
  <b-row no-gutters>
    <b-col>
      <div class="py-2 px-3 boxed">
        <p v-if="showTitle" class="mb-0 font-weight-bold">{{ $t('scoringProfiles.profileCoverage') }}</p>
        <b-list-group v-if="dataCoverage" :class="{ 'mt-2': showTitle }" horizontal>
          <b-list-group-item
            v-for="(item, key, index) in dataCoverage"
            :key="key"
            class="m-0 p-0 bg-transparent border-none"
          >
            <span class="font-weight-bold">{{ item }}</span>
            <span class="ml-2">{{ $t(`scoringProfiles.${key}`) }}</span>
            <span class="mx-2" v-if="index !== Object.keys(dataCoverage).length - 1">-</span>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    dataCoverage: Object,
    // The "Copertura profilo" heading. Kept (default) where the component is standalone (Create/Edit);
    // hidden when rendered as the band inside the "Caratteristiche profilo" panel.
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
.border-none {
  border: 0;
}
.boxed {
  background-color: var(--secondaryBGColor);
}
</style>
